import {
  SET_UPGRADE_REQUESTED,
  SET_UPGRADE_REQUESTED_FETCHING,
} from 'constants/actions';

export const setUpgradeRequested = requestStatus => {
  return {
    type: SET_UPGRADE_REQUESTED,
    requestStatus,
  };
};
export const setUpgradeRequestedFetching = fetching => {
  return {
    type: SET_UPGRADE_REQUESTED_FETCHING,
    fetching,
  };
};
